// run-command-last-run-tracking.ts — 06k vòng sửa review, tách khỏi
// autopilot-run-command.ts (trần 200 dòng):
//  - callback `onMachineLockAcquired`: ghi `running` (kèm `process_started_at` — L6
//    pid tái dùng, và `log_path` của con tách rời), rồi CHỈ con tách rời đã giành
//    lock xoay log (L-04/L7: không bao giờ xoá log của supervisor đang sống);
//  - dòng `run --json` dự phòng (L5): `buildRunJsonResult` lỗi hoặc run ném lỗi ⇒
//    vẫn đúng MỘT dòng stdout `{mission_id, outcome, exit_code, ended_at}`.
import { realLivenessProbe } from "./process-liveness-probe.js";
import { runCommandExitCode } from "./run-command-outcome-observability.js";
import { rotateRunLogs } from "./run-detached-launcher.js";
import { writeLastRunRunning } from "./run-last-outcome-file.js";
import type { RunMissionResult } from "./supervisor-mission-run.js";

export interface LastRunTrackingInput {
  controlRoot: string;
  runId: string;
  detached: boolean;
  logPath?: string;
  warn: (message: string) => void;
}

export function lastRunOnLockAcquired(input: LastRunTrackingInput): () => Promise<void> {
  return async () => {
    try {
      await writeLastRunRunning(input.controlRoot, {
        runId: input.runId,
        pid: process.pid,
        detached: input.detached,
        logPath: input.logPath,
        processStartedAt: await realLivenessProbe.processStartedAt(process.pid),
      });
    } catch (err) {
      input.warn(`Không ghi được last-run.json: ${String(err)}`);
    }
    if (input.detached) rotateRunLogs(input.controlRoot, input.logPath);
  };
}

export interface RunJsonFallback {
  mission_id: string;
  outcome: string;
  exit_code: number;
  ended_at: string;
}

export function runJsonFallback(
  missionId: string,
  result: RunMissionResult | undefined,
): RunJsonFallback {
  return {
    mission_id: missionId,
    outcome: result?.outcome ?? "error",
    exit_code: result === undefined ? 1 : runCommandExitCode(result),
    ended_at: new Date().toISOString(),
  };
}
